import React, { createRef } from 'react';
import SwipeableViews from 'react-swipeable-views';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';

import Items from './Items';
import CluesExplores from './CluesExplores';
import Banks from './Banks';
import Psp from './Psp';
import ProviderStoryboards from './ProviderStoryboards';

import styles from './ProviderOthers.module.scss';

export default class ProviderOthers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 0,
      scrollY: 0,
    };

    this.scrollRef = createRef();
    this.onChangeTab = this.onChangeTab.bind(this);
    this.onChangeTabIndex = this.onChangeTabIndex.bind(this);
    this.scrollableContainer = null;
  }


  componentDidUpdate(prevProps) {
    if(prevProps.isSaving && !this.props.isSaving) {
      if(this.props.itemScrollPos) {
        const scrollWrapper = this.scrollRef.current;
        const scrollElement = scrollWrapper.children[1];
        if(scrollElement) {
          setTimeout(() => {
            scrollElement.scrollTop = this.props.itemScrollPos;
          }, 1000)
        }
      }
    }
  }

  componentDidMount() {
    const scrollWrapper = this.scrollRef.current;
    if(scrollWrapper) {
      scrollWrapper.children[1].addEventListener('scroll', this.handleScroll)
    }
  }

   componentWillUnmount() {
    const scrollWrapper = this.scrollRef.current;
    if(scrollWrapper) {
      scrollWrapper.children[1].removeEventListener('scroll', this.handleScroll)
    }
  }

  onChangeTab = (event, tab) => {
    this.setState({ tab: tab });
  };

  onChangeTabIndex = (index) => {
    this.setState({ tab: index });
  };

  handleScroll = () => {
    const scrollWrapper = this.scrollRef.current;
    if(scrollWrapper) {
    
      const scrollElement = scrollWrapper.children[1];

      if(scrollElement) {
        this.props.providerItemsScrollPosFunc(scrollElement.scrollTop);
      }
    }
  };


  render() {
    const isEnabledStoryboard = this.props.isEnabledStoryboard || false;
    return (
      <div ref={this.scrollRef} className={styles.root}>
        {isEnabledStoryboard?
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.tab}
            onChange={this.onChangeTab}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              label="Storyboards"
              style={{
                backgroundColor: 'white',
                textTransform: 'none',
                fontSize: '14px',
                maxWidth: '100px',                
                minWidth: '100px'
              }}
            />
            <Tab
              label="Items"
              style={{
                backgroundColor: 'white',
                textTransform: 'none',
                fontSize: '14px',
                maxWidth: '100px',
                minWidth: '100px'
              }}
            />
            <Tab
              label="Clues"
              style={{
                backgroundColor: 'white',
                textTransform: 'none',
                fontSize: '14px',
                maxWidth: '100px',
                minWidth: '100px'
              }}
            />
            <Tab
              label="Bank"
              style={{
                backgroundColor: 'white',
                textTransform: 'none',
                fontSize: '14px',
                maxWidth: '100px',
                minWidth: '100px'
              }}
            />
            <Tab
              label="PSP"
              style={{
                backgroundColor: 'white',
                textTransform: 'none',
                fontSize: '14px',
                maxWidth: '100px',
                minWidth: '100px'
              }}
            />
          </Tabs>
        </AppBar>:
        <AppBar position="static" color="default">
        <Tabs
          value={this.state.tab}
          onChange={this.onChangeTab}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            label="Items"
            style={{
              backgroundColor: 'white',
              textTransform: 'none',
              fontSize: '16px',
              maxWidth: '140px',
              minWidth: '140px'
            }}
          />
          <Tab
            label="Clues/Explore"
            style={{
              backgroundColor: 'white',
              textTransform: 'none',
              fontSize: '16px',
              maxWidth: '140px',
              minWidth: '140px'
            }}
          />
          <Tab
            label="PSP"
            style={{
              backgroundColor: 'white',
              textTransform: 'none',
              fontSize: '16px',
              maxWidth: '140px',
              minWidth: '140px'
            }}
          />
        </Tabs>
      </AppBar>
        }
        {isEnabledStoryboard?
        <SwipeableViews axis="x" index={this.state.tab} onChangeIndex={this.onChangeTabIndex}>
          <ProviderStoryboards
            pois={this.props.pois}
            storyboard={this.props.storyboard}
            storyboards={this.props.storyboards}
            providerId={this.props.providerId}
            onSelectStoryboardFunc={this.props.onSelectStoryboardFunc}
            onSaveStoryboardFunc={this.props.onSaveStoryboardFunc}
            onDeleteStoryboardFunc={this.props.onDeleteStoryboardFunc}
            onUploadStoryboardMediaFunc={this.props.onUploadStoryboardMediaFunc}
            onClearStoryboardMediaFunc={this.props.onClearStoryboardMediaFunc}
            onCloneStoryboardFunc={this.props.onCloneStoryboardFunc}
            storyboardMedia={this.props.storyboardMedia}
            uploadMediaFunc={this.props.uploadMediaFunc}
            provider = {this.props.provider}
          />
          <Items
            item={this.props.item}
            items={this.props.items}
            currencySymbol={this.props.currencySymbol}
            media={this.props.itemMedia}
            onSelectItemFunc={this.props.onSelectItemFunc}
            onSaveItemFunc={this.props.onSaveItemFunc}
            onCloneItemFunc={this.props.onCloneItemFunc}
            uploadMediaFunc={this.props.uploadMediaFunc}
            onBulkDeleteItemsFunc={this.props.onBulkDeleteItemsFunc}
            bulkDeleteInProgress={this.props.bulkDeleteInProgress}
          />
          <CluesExplores
            clue={this.props.clue}
            clues={this.props.clues}
            poi={this.props.poi}
            pois={this.props.pois}
            providerId={this.props.providerId}
            onSelectClueFunc={this.props.onSelectClueFunc}
            onSaveClueFunc={this.props.onSaveClueFunc}
            onSelectPOIFunc={this.props.onSelectPOIFunc}
            onSavePOIFunc={this.props.onSavePOIFunc}
            onUploadClueFunc={this.props.onUploadClueFunc}
            onSavePOIsFunc={this.props.onSavePOIsFunc}
            onUploadPOIMediaFunc={this.props.onUploadPOIMediaFunc}
            onClearPOIMediaFunc={this.props.onClearPOIMediaFunc}
            poiMedia={this.props.poiMedia}
            uploadMediaFunc={this.props.uploadMediaFunc}
            provider = {this.props.provider}
          />
          <Banks
            clue={this.props.clue}
            clues={this.props.clues}
            poi={this.props.poi}
            pois={this.props.pois}
            storyboards={this.props.storyboards}
            providerId={this.props.providerId}
            onSelectClueFunc={this.props.onSelectClueFunc}
            onSaveClueFunc={this.props.onSaveClueFunc}
            onSelectPOIFunc={this.props.onSelectPOIFunc}
            onSavePOIFunc={this.props.onSavePOIFunc}
            onUploadClueFunc={this.props.onUploadClueFunc}
            onSavePOIsFunc={this.props.onSavePOIsFunc}
            onUploadPOIMediaFunc={this.props.onUploadPOIMediaFunc}
            onClearPOIMediaFunc={this.props.onClearPOIMediaFunc}
            poiMedia={this.props.poiMedia}
            uploadMediaFunc={this.props.uploadMediaFunc}
            provider = {this.props.provider}
          />
          <Psp
            linkedUsers={this.props.linkedUsers}
            provider = {this.props.provider}
            getProviderLinkedUsersFunc={this.props.getProviderLinkedUsersFunc}
            deleteProviderLinkedUserFunc={this.props.deleteProviderLinkedUserFunc}
          />
        </SwipeableViews>:
        <SwipeableViews axis="x" index={this.state.tab} onChangeIndex={this.onChangeTabIndex}>
        <Items
          item={this.props.item}
          items={this.props.items}
          currencySymbol={this.props.currencySymbol}
          media={this.props.itemMedia}
          onSelectItemFunc={this.props.onSelectItemFunc}
          onSaveItemFunc={this.props.onSaveItemFunc}
          onCloneItemFunc={this.props.onCloneItemFunc}
          uploadMediaFunc={this.props.uploadMediaFunc}
          onBulkDeleteItemsFunc={this.props.onBulkDeleteItemsFunc}
          bulkDeleteInProgress={this.props.bulkDeleteInProgress}
        />
        <CluesExplores
          clue={this.props.clue}
          clues={this.props.clues}
          poi={this.props.poi}
          pois={this.props.pois}
          providerId={this.props.providerId}
          onSelectClueFunc={this.props.onSelectClueFunc}
          onSaveClueFunc={this.props.onSaveClueFunc}
          onSelectPOIFunc={this.props.onSelectPOIFunc}
          onSavePOIFunc={this.props.onSavePOIFunc}
          onUploadClueFunc={this.props.onUploadClueFunc}
          onSavePOIsFunc={this.props.onSavePOIsFunc}
          onUploadPOIMediaFunc={this.props.onUploadPOIMediaFunc}
          onClearPOIMediaFunc={this.props.onClearPOIMediaFunc}
          poiMedia={this.props.poiMedia}
          uploadMediaFunc={this.props.uploadMediaFunc}
          provider = {this.props.provider}
          isEnabledStoryboard ={isEnabledStoryboard?isEnabledStoryboard:true}
        />
        <Psp
            linkedUsers={this.props.linkedUsers}
            provider = {this.props.provider}
            getProviderLinkedUsersFunc={this.props.getProviderLinkedUsersFunc}
            deleteProviderLinkedUserFunc={this.props.deleteProviderLinkedUserFunc}

          />
      </SwipeableViews>
        }
      </div>
    );
  }
}
